module.exports = __webpack_public_path__ + "img/np.930773de.svg";